import { useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Container } from '@tribeplatform/react-ui-kit/Layout'

import { CurrentDomain } from './CurrentDomain.js'
import { TransferWizard } from './TransferWizard.js'

export const Domain = () => {
  const { $t } = useI18n()

  const { data: network, isRefetching: isRefetchingNetwork } = useNetwork({
    ignorePlaceholderData: true,
    fields: {
      limits: 'all',
      usages: 'all',
    },
    useQueryOptions: {
      refetchOnWindowFocus: false,
    },
  })

  if (!network) {
    return null
  }

  const { domain, domainSubfolder, newDomain, limits } = network

  return (
    <Container size="lg" alignment="start">
      <Card className="w-full">
        <Card.Header
          title={$t({
            defaultMessage: 'Domain settings',
            id: 'Generics.DomainSettings',
          })}
        />
        <Card.Content>
          <Container size="full" spacing="sm">
            <CurrentDomain
              domainInfo={{
                domain,
                domainSubfolder,
              }}
            />
            <TransferWizard
              isRefetchingNetwork={isRefetchingNetwork}
              currentNominee={newDomain}
              canUseCustomDomain={limits.usageLimits.customDomain}
            />
          </Container>
        </Card.Content>
      </Card>
    </Container>
  )
}
